import { render, staticRenderFns } from "./TelegramChannels.vue?vue&type=template&id=290e1b94&scoped=true"
import script from "./TelegramChannels.vue?vue&type=script&lang=js"
export * from "./TelegramChannels.vue?vue&type=script&lang=js"
import style0 from "./TelegramChannels.vue?vue&type=style&index=0&id=290e1b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e1b94",
  null
  
)

export default component.exports